module.exports = __webpack_public_path__ + "static/media/warning-white.89a06f9c.svg";